import React from 'react'
import isEmpty from 'lodash-es/isEmpty'
import get from 'lodash-es/get'

import { IContestEntry, IContest } from 'protos'

import List from '@material-ui/core/List'

import EventRankingItem from 'components/EventRankingItem'
import EventRankingEmptyState from 'components/EventRankingEmptyState'

export interface Props {
  contest?: IContest | null
  entries?: IContestEntry[] | null
  onClickAvatar?: (userId: string) => void
}

interface State {
  selectedUserId: string
}

class EventRanking extends React.Component<Props, State> {
  static defaultProps: Props = {
    entries: []
  }

  constructor(props: Props) {
    super(props)
    this.state = { selectedUserId: '' }
  }

  private onClickEntry = (selectedUserId: string) => {
    if (selectedUserId === this.state.selectedUserId) {
      selectedUserId = ''
    }

    this.setState({ ...this.state, selectedUserId })
  }

  render() {
    if (isEmpty(this.props.entries)) {
      return <EventRankingEmptyState />
    }

    const ownEntry = get(this.props, 'contest.ownEntry')

    return (
      <List style={{ padding: 0 }}>
        {ownEntry && (
          <EventRankingItem entry={ownEntry} isOwnEntry />
        )}
        {this.props.entries!.map((entry, i) => {
          const isUserIdNotEmpty = !!(entry.user && entry.user.userId)
          const isDropdownActive = isUserIdNotEmpty && entry.user!.userId === this.state.selectedUserId

          return (
            <EventRankingItem
              key={`entry-${entry.user ? entry.user.userId : i}`}
              entry={entry}
              contest={this.props.contest}
              onClick={this.onClickEntry}
              onClickAvatar={this.props.onClickAvatar}
              isDropdownActive={isDropdownActive}
            />
          )
        })}
      </List>
    )
  }
}

export default EventRanking
